type FallBackPopupListener = () => void;

let isFallBackPopupOpen = false;

const listeners = new Set<FallBackPopupListener>();

const emitChange = () => {
  listeners.forEach((listener) => listener());
};

/**
 * Shared fallback-popup state used by SSO flows and popup hosts.
 * A single module-level store is required because SSO handlers trigger the
 * popup without knowing which route layout currently mounted the component.
 */
export const showFallBackPopup = (): boolean => isFallBackPopupOpen;

export const getFallBackPopupSnapshot = (): boolean => isFallBackPopupOpen;

export const subscribeToFallBackPopup = (listener: FallBackPopupListener): (() => void) => {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
};

export const setShowFallBackPopup = (nextValue: boolean): void => {
  if (isFallBackPopupOpen === nextValue) {
    return;
  }

  isFallBackPopupOpen = nextValue;
  emitChange();
};

export const triggerFallBackPopup = (): void => {
  setShowFallBackPopup(true);
};

export const closeFallBackPopup = (): void => {
  setShowFallBackPopup(false);
};
